import {Component, Input} from '@angular/core';
import {TranslocoService} from "@ngneat/transloco";
import {EventItem} from "../../model/event-item";

@Component({
  selector: 'app-event-grid-item',
  templateUrl: './event-grid-item.component.html',
  styleUrls: ['./event-grid-item.component.scss']
})
export class EventGridItemComponent {
  @Input() eventItem: EventItem | undefined;
  @Input() itemClass: string | undefined;

  constructor(public translocoService: TranslocoService) {
  }

}
